import { socialMedia } from '../../api/profile'

export default {
    state: {
        socialMediaState: null
    },

    getters: {
        socialMedia: state => state.socialMediaState
    },

    mutations: {
        getSocialMedia(state, payload) {
            state.socialMediaState = payload
        },

        saveSocialMedia(state, payload) {
            let stateRef = state.socialMediaState

            if (payload.editId) {
                let record = stateRef.find(item => item.id === payload.editId)
                stateRef.splice(stateRef.indexOf(record), 1, payload.newData)
            }
            else {
                stateRef.push(payload.newData)
            }
        }
    },

    actions: {
        getSocialMedia({ commit, state, rootGetters }) {
            let profileId = rootGetters['profile/memberId'],
                entityId = rootGetters['profile/entityId'];

            if (_.isEmpty(state.socialState)) {
                axios.get(socialMedia(entityId, profileId))
                    .then(response => {
                        commit('getSocialMedia', response.data.socialMedia)
                    })
                    .catch(() => {})
            }
        },

        saveSocialMedia({ commit, rootGetters }, formData) {
            let profileId = rootGetters['profile/memberId'],
                entityId = rootGetters['profile/entityId'],
                requestUrl = socialMedia(entityId, profileId),
                requestType = 'post';

            if (formData.editId) {
                requestUrl += `/${formData.editId}`;
                requestType = 'put';
            }

            const promise = axios[requestType](requestUrl, formData.newData);

            promise.then(
                response => {
                    commit('saveSocialMedia', {
                        editId : formData.editId,
                        newData: response.data.socialMedia
                    });
                },
                error => {}
            );

            return promise;
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/profile/socials.js